import React, { useState } from "react";
import { Copy, Download } from "react-feather";
import { connect } from "react-redux";
import { Card, CardBody } from "reactstrap";
import excelImg from "./excel.jpeg";

import {
  Button,
  Col,
  Drawer,
  message,
  Modal,
  Row,
  Table,
  Tag,
  Select,
} from "antd";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { H5 } from "../../../../AbstractElements";
import { EstimatePdfOpenApi, ProjectApi, TaxOptionAPI } from "../../../../api";
import {
  changeEstimateStatus,
  createEstimateDuplicate,
  estimateExcelApi,
  fetchEstimateRevisionData,
  fetchEstimatesList,
  getEstimateDetails,
} from "../../../../api/estimate.api";
import { fetchOrganisationDetails } from "../../../../api/organisation.api";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
import {
  EyeOutlined,
  FileExcelFilled,
  FileExcelOutlined,
} from "@ant-design/icons";
import { QuotePreview } from "./preview";
import DeliveryDrawer from "./deliveryDrawer";

const Estimate = (props) => {
  const [estimates, setEstimates] = React.useState([]);
  const [createdByMembers, setCreatedByMembers] = useState([]);
  const [assignedByMembers, setAssignedByMembers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewData, setPreviewData] = useState({
    currentGst: null,
    projectDetails: null,
    dataSource: null,
    user: null,
    additionalCharges: null,
    totalAdditonalCharge: null,
    billToDisplayAddress: null,
    shipToDisplayAddress: null,
    paymentTerms: null,
    createEstimate: null,
    terms_and_conditions_description: null,
  });

  const [showDeliveryDrawer, setShowDeliveryDrawer] = useState(false);
  const [currentEstimate, setCurrentEstimate] = useState(null);
  const [revisionData, setRevisionData] = useState(null);
  const [loading, setLoading] = React.useState(true);
  const [phone_not_present, setPhoneNotPresent] = React.useState(true);
  const history = useNavigate();
  const [estimateRevisionDrawer, setEstimateRevisionDrawer] = useState(false);
  const [organisationDetails, setOrganisationDetails] = React.useState(null);
  const [taxOptions, setTaxOptions] = React.useState([]);
  const { userDetails, setUserDetails } = useAPIUser();
  const { Option } = Select;

  const statusOptions = [
    { id: "1", value: "draft", label: "Draft" },
    {
      id: "2",
      value: "pricing_and_availability_check",
      label: "Pricing and Availability Check",
    },
    {
      id: "3",
      value: "availability_check",
      label: "Availability Check",
    },
    {
      id: "4",
      value: "quote_approval_pending",
      label: "Quote Approval pending",
    },
    {
      id: "5",
      value: "quotation_approved",
      label: "Quotation Approved - Initiate Delivery",
    },
    {
      id: "6",
      value: "order_lost",
      label: "Order Lost",
    },
    {
      id: "7",
      value: "vendor_po_raised",
      label: "Vendor Po Raised",
    },
    {
      id: "8",
      value: "dispatched",
      label: "Dispatched",
    },
    {
      id: "9",
      value: "delivered",
      label: "Delivered",
    },
  ];

  const fetchTaxOptions = () => {
    axios.get(`${TaxOptionAPI}`).then((res) => {
      setTaxOptions(
        res.data?.filter(
          (each) =>
            each.organisation === userDetails?.organisation?.organisation_id
        )
      );
    });
  };

  const onDeliveryFinish = (deliveryValues) => {
    changeEstimateStatus({
      estimate_id: currentEstimate?.id,
      data: {
        estimate_status: currentEstimate?.estimate_status,
        ...deliveryValues,
      },
    }).then((res) => {
      message.success("Delivery status updated successfully");
      setShowDeliveryDrawer(false);
      fetchEstimates(props.settings?.project?.id);
    });
  };

  const getOrganisationDetails = () => {
    fetchOrganisationDetails().then((res) => {
      setOrganisationDetails(res);
    });
  };
  const getFormattedDate = (date) => {
    const formattedDate =
      // moment(date).format("ddd") +
      // " " +
      moment(date).format("MMM") +
      " " +
      moment(date).format("DD") +
      " " +
      moment(date).format("YYYY");

    return formattedDate;
  };
  const columns = [
    {
      title: "Lead ID",
      key: "lead_id",
      dataIndex: "lead_id",
      sorter: (a, b) => {
        return a.lead_id.localeCompare(b.lead_id);
      },
      width: 160,
    },
    {
      title: "Pro Forma Invoice No.",
      key: "estimate_no",
      dataIndex: "estimate_no",
      sorter: (a, b) => {
        return a.estimate_no.localeCompare(b.estimate_no);
      },
    },
    {
      title: "Creation date",
      key: "creation_date",
      dateFormat: "MMM DD YYYY",
      sorter: (a, b) => {
        return a.created_at.localeCompare(b.created_at);
      },
      render: (data) => (
        <>{getFormattedDate(data?.created_at_old ?? data?.created_at)}</>
      ),
    },
    {
      title: "Created by",
      key: "created_by__name",
      dataIndex: "created_by__name",
      filters: createdByMembers,
      onFilter: (value, record) =>
        record?.created_by__name?.indexOf(value) === 0,
    },
    {
      title: "Assigned to",
      key: "assigned_to__name",
      dataIndex: "assigned_to__name",
      filters: assignedByMembers,
      onFilter: (value, record) =>
        record?.assigned_to__name?.indexOf(value) === 0,
    },
    {
      title: "Status",
      key: "status",
      width: 200,
      render: (data) => (
        <Select
          className="w-100"
          key={"estimate_status"}
          defaultValue={data?.estimate_status ?? "draft"}
          value={data?.estimate_status ?? "draft"}
          onChange={(e) => {
            setLoading(true);
            if (
              statusOptions.findIndex((x) => x.value === e) >=
                statusOptions.findIndex(
                  (x) => x.value === "quotation_approved"
                ) &&
              !data?.ship_address &&
              e !== "order_lost"
            ) {
              // Show the delivery drawer
              setShowDeliveryDrawer(true);
              setCurrentEstimate({
                ...data,
                estimate_status: e,
              });
            } else {
              changeEstimateStatus({
                estimate_id: data.id,
                data: { estimate_status: e },
              }).then((res) => {
                fetchEstimates(props.settings?.project?.id);
              });
            }
          }}
        >
          {statusOptions?.map((each, index) => (
            <Option
              // disabled={
              //   index <
              //   statusOptions.findIndex(
              //     (status) => status.value === data?.estimate_status
              //   )
              // }
              value={each?.value}
              key={each?.id}
            >
              {each?.label}
            </Option>
          ))}
        </Select>
      ),
      filters: Array.from(
        new Set(
          estimates.map((a) =>
            a.estimate_status ? a.estimate_status : "draft"
          )
        )
      ).map((status) => ({
        text: statusOptions.find((each) => each.value === status)?.label,
        value: status,
      })),
      onFilter: (value, record) =>
        value === "draft"
          ? record.estimate_status === null
          : record.estimate_status?.indexOf(value) === 0,
    },
    // {
    //   title: "Revision No.",
    //   key: "revision_no",
    //   dataIndex: "revision_no",
    // },
    {
      title: "Total",
      key: "total_estimate_amount",
      sorter: (a, b) => {
        return a.total_estimate_amount?.localeCompare(b.total_estimate_amount);
      },
      render: (data) => (
        <>{parseFloat(data?.total_estimate_amount ?? 0)?.toFixed(2)}</>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 240,
      render: (data) => {
        return (
          <Row>
            <Tag
              className="mr-1"
              onClick={() => {
                // setModal2Visible(true);
                // setPoDetails(data);
                history("/app/project/estimate-details/" + data?.id);
              }}
              // color={"blue"}
              style={{ cursor: "pointer" }}
            >
              Details
            </Tag>
            <EyeOutlined
              style={{
                fontSize: 20,
                cursor: "pointer",
              }}
              onClick={() => {
                setLoading(true);

                getEstimateDetails(data?.id).then((res) => {
                  setIsModalOpen(true);
                  setPreviewData({
                    currentGst: res.gst,
                    projectDetails: res.project,
                    dataSource: res.estimate_items,
                    user: {
                      name: res.created_by,
                    },
                    additionalCharges: res.estimate_additional_charges,
                    billToDisplayAddress: res.bill_address,
                    shipToDisplayAddress: res.ship_address,
                    paymentTerms: res.estimate_payment_terms,
                    terms_and_conditions_description:
                      res.terms_and_conditions_description,
                  });
                  setLoading(false);
                });
              }}
            />
            <FileExcelFilled
              style={{
                fontSize: 24,
                cursor: "pointer",
                color: "#209D60",
              }}
              className="mr-2 ml-2"
              onClick={async () => {
                setLoading(true);
                if (data?.gsheet_link) {
                  window.open(data?.gsheet_link, "_blank");
                } else {
                  await estimateExcelApi(data?.id).then((res) => {
                    window.open(res, "_blank");
                  });
                }
                setLoading(false);
              }}
            />
            <Download
              className="mr-1"
              onClick={() => {
                // setModal2Visible(true);
                // setPoDetails(data);
                // history("/app/project/estimate-details/" + data?.id);
                window.open(
                  EstimatePdfOpenApi +
                    data?.id +
                    (data.image ? "?image=true" : ""),
                  "_blank"
                );
              }}
            />
            <Copy
              onClick={() => {
                message.loading({
                  content: "Action in progress..",
                  duration: 30,
                  key: "duplicate",
                });
                createEstimateDuplicate(data?.id).then((res) => {
                  if (res) {
                    message.success({
                      type: "success",
                      content: "Duplicate created successfully",
                      duration: 2,
                      key: "duplicate",
                    });
                  } else {
                    message.warning({
                      type: "warning",
                      content: "Something went wrong please try again later.",
                      duration: 2,
                      key: "duplicate",
                    });
                  }
                  const projectId = props.settings?.project?.id;
                  fetchEstimatesList(projectId)
                    .then((res) => {
                      let final_data = res.map((item) => {
                        if (item.estimate?.length > 0) {
                          return { ...item, children: item.estimate };
                        } else {
                          return item;
                        }
                      });
                      setEstimates(final_data);
                      setLoading(false);
                    })
                    .catch(() => {
                      setEstimates([]);
                      setLoading(false);
                    });
                });
              }}
            />
          </Row>
        );
      },
    },
    {
      title: "Revisions",
      key: "revisions",
      render: (data) => {
        return (
          <Tag
            onClick={() => {
              setEstimateRevisionDrawer(true);
              fetchEstimateRevisionData(data.estimate_no).then((res) => {
                setRevisionData(res?.reverse());
              });
            }}
            color={"orange"}
            style={{ cursor: "pointer" }}
          >
            Revisions
          </Tag>
        );
      },
    },
  ];

  const fetchEstimates = (projectId) => {
    fetchEstimatesList(projectId)
      .then((res) => {
        let createdByList = [];
        let assignedByList = [];
        let final_data = res.map((item) => {
          if (
            createdByList.findIndex(
              (member) => member.text == item.created_by__name
            ) < 0
          ) {
            createdByList.push({
              text: item.created_by__name,
              value: item.created_by__name,
            });
          }
          if (
            assignedByList.findIndex(
              (member) => member.text == item.assigned_to__name
            ) < 0
          ) {
            assignedByList.push({
              text: item.assigned_to__name,
              value: item.assigned_to__name,
            });
          }
          if (item.estimate?.length > 0) {
            return { ...item, children: item.estimate };
          } else {
            return item;
          }
        });
        setEstimates(final_data);

        setCreatedByMembers(createdByList);
        setAssignedByMembers(assignedByList);
        setLoading(false);
      })
      .catch(() => {
        setEstimates([]);
        setLoading(false);
      });
  };

  const fetchProjectDetails = () => {
    axios.get(`${ProjectApi}${props.settings.project.id}/`).then((res) => {
      console.log(
        "res.data",
        res.data?.contact_phone,
        res.data?.contact_phone?.toString() > 0,
        res.data
      );
      if (res.data?.contact_phone && res.data?.contact_phone?.toString()) {
        setPhoneNotPresent(false);
      }
    });
  };
  React.useEffect(() => {
    const projectId = props.settings?.project?.id;
    fetchTaxOptions();
    getOrganisationDetails();
    fetchProjectDetails();
    fetchEstimates(projectId);
  }, [props.settings?.project?.id]);

  const getPreview = ({
    currentGst,
    projectDetails,
    dataSource,
    user,
    additionalCharges,
    billToDisplayAddress,
    shipToDisplayAddress,
    paymentTerms,
    terms_and_conditions_description,
  }) => {
    return (
      <QuotePreview
        projectDetails={projectDetails}
        user={user}
        currentGst={currentGst}
        billTo={billToDisplayAddress}
        shipTo={shipToDisplayAddress}
        terms={terms_and_conditions_description}
        dataSource={dataSource}
        branch={props?.settings?.branch}
        additionalCharges={additionalCharges}
        organisationDetails={organisationDetails}
        paymentTerms={paymentTerms}
      />
    );
  };
  return (
    <section>
      <Card>
        <CardBody>
          <div class="d-flex align-center">
            <H5>Pro Forma Invoices</H5>
          </div>
          <section className="my-2">
            {/* <Button
              onClick={() => {
                if (phone_not_present) {
                  message.info(
                    "Please enter contact in project settings to make pro forma invoice",
                    5
                  );
                } else {
                  history(`/app/project/estimates/form`, {});
                }
              }}
              className="btn btn-primary d-flex align-items-center justify-content-center text-white"
            >
              Create Pro Forma Invoice
            </Button> */}
          </section>
          <Table
            loading={loading}
            columns={columns}
            dataSource={estimates}
            pagination={false}
            scroll={{ x: "100%" }}
            rowKey={"id"}
          />
        </CardBody>
      </Card>

      <Drawer
        title={"Pro Forma Invoice Details"}
        width={800}
        onClose={() => {
          setEstimateRevisionDrawer(false);
        }}
        visible={estimateRevisionDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          ></div>
        }
      >
        {!revisionData && <div className="mt-2">Loading...</div>}
        {revisionData?.map((data, index) => {
          return (
            <Card key={(index + Math.random())?.toString()}>
              <CardBody>
                <Row>
                  <Col sm={12} style={{ margin: "auto" }}>
                    <Col sm={24}>
                      <Col
                        style={{
                          fontSize: "12px",
                          color: "#928d8d",
                          fontWeight: "500",
                        }}
                      >
                        Lead Id{" "}
                      </Col>
                      <Col className="fw-bold" style={{ fontSize: "22px" }}>
                        {data?.lead_id}
                      </Col>
                    </Col>
                    <Col
                      sm={24}
                      style={{
                        fontSize: "14px",
                        color: "#928d8d",
                        fontWeight: "500",
                      }}
                    >
                      Created by{" "}
                      <span className="fw-bold" style={{ color: "#000" }}>
                        {" "}
                        {data?.revised_by__name}{" "}
                      </span>
                    </Col>{" "}
                    <Col
                      sm={12}
                      style={{
                        fontSize: "14px",
                        color: "#928d8d",
                        fontWeight: "500",
                      }}
                    >
                      Created at:
                      <span className="fw-bold" style={{ color: "#000" }}>
                        {getFormattedDate(data?.modified_at)}
                      </span>
                    </Col>{" "}
                    <Col sm={20}>
                      <Button
                        onClick={(e) => {
                          history("/app/project/estimate-details/" + data?.id);
                        }}
                        type="primary"
                        className="btn d-flex align-items-center justify-content-center border go-to-po-btn"
                      >
                        <div
                          style={{
                            marginLeft: "4px",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                          }}
                        >
                          See Estimate
                        </div>
                      </Button>
                    </Col>
                  </Col>
                  <Col sm={12}>
                    <div style={{ height: 42 }}></div>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Pro Forma Invoice No:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {data?.estimate_no}{" "}
                        {data?.revision && `(R${data?.revision})`}
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Status:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        <Tag
                          style={{ textTransform: "capitalize" }}
                          color={
                            data?.estimate_status != "Raised" ? "gold" : "green"
                          }
                        >
                          {data.estimate_status ?? "Raised"}
                        </Tag>
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Total:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {Number(data?.total_estimate_amount)?.toFixed(2)}
                      </Col>
                    </Row>

                    <Row
                      style={{
                        background: "#f2f2f2",
                        padding: "2px 10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Col sm={12} className="" style={{ fontSize: "12px" }}>
                        Inclusive of all taxes
                      </Col>
                      <Col
                        sm={12}
                        className="text-right fw-bold"
                        style={{ fontSize: "25px" }}
                      >
                        {"₹"}
                        {Number(data?.total_estimate_amount)?.toFixed(2)}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          );
        })}
      </Drawer>

      <DeliveryDrawer
        onClose={(unsetLoading = false) => {
          setShowDeliveryDrawer(false);
          if (unsetLoading) {
            setLoading(false);
          }
        }}
        visible={showDeliveryDrawer}
        onFinish={onDeliveryFinish}
        deliveryDetails={{
          delivery_poc: estimates,
        }}
      />

      <Modal
        // style={{ width: 1000 }}
        width="70%"
        centered
        visible={isModalOpen}
        closeIcon={null}
        onCancel={() => setIsModalOpen(false)}
        okText={""}
        onOk={() => {}}
      >
        {getPreview({
          ...previewData,
        })}
      </Modal>
    </section>
  );
};

const mapStateToProps = ({ dispatch, settings }) => {
  return {
    dispatch,
    settings,
  };
};

export default connect(mapStateToProps)(Estimate);
